/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductModel
 */
export interface ProductModel {
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    productID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    productName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    interval?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    currency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductModel
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    priceID?: string | null;
}

/**
 * Check if a given object implements the ProductModel interface.
 */
export function instanceOfProductModel(value: object): value is ProductModel {
    return true;
}

export function ProductModelFromJSON(json: any): ProductModel {
    return ProductModelFromJSONTyped(json, false);
}

export function ProductModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductModel {
    if (json == null) {
        return json;
    }
    return {
        
        'productID': json['productID'] == null ? undefined : json['productID'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'interval': json['interval'] == null ? undefined : json['interval'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'price': json['price'] == null ? undefined : json['price'],
        'priceID': json['priceID'] == null ? undefined : json['priceID'],
    };
}

export function ProductModelToJSON(json: any): ProductModel {
    return ProductModelToJSONTyped(json, false);
}

export function ProductModelToJSONTyped(value?: ProductModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productID': value['productID'],
        'productName': value['productName'],
        'interval': value['interval'],
        'currency': value['currency'],
        'price': value['price'],
        'priceID': value['priceID'],
    };
}

